<tds-side-menu aria-label="Side menu" persistent collapsed = "true" [open]="mobileNavOpen">
  
<tds-side-menu-overlay (click)="toggleMobileSideMenu()" slot="overlay"></tds-side-menu-overlay>

<tds-side-menu-close-button slot="close-button" (click)="toggleMobileSideMenu()"></tds-side-menu-close-button>

<tds-side-menu-item [selected]="isActive('/home')">
  <a [routerLink]="['/home']" (click)="toggleMobileSideMenu()">
    <tds-icon name="home" size="24"></tds-icon>
      Home
  </a>
</tds-side-menu-item>

<tds-side-menu-dropdown
  class="reservation-menu-item"
  [class.reservation-selected]="isReservationSectionSelected"
  [selected]="isReservationSectionSelected">
  <tds-icon class="reservation-menu-icon" slot="icon" name="calendar" size="24"></tds-icon>
  <span slot="label">Reservas</span>

  <tds-side-menu-dropdown-list>
      
    <tds-side-menu-dropdown-list-item [selected]="onSubRoute('/reservation')">
      <a routerLink="/reservation" (click)="toggleMobileSideMenu()">Nova reserva</a>
    </tds-side-menu-dropdown-list-item>

    <tds-side-menu-dropdown-list-item [selected]="onSubRoute('/history')">
      <a routerLink="/history" (click)="toggleMobileSideMenu()">Histórico</a>
    </tds-side-menu-dropdown-list-item>

    <tds-side-menu-dropdown-list-item [selected]="onSubRoute('/checkin')">
      <a routerLink="/checkin" (click)="toggleMobileSideMenu()">Check-In</a>
    </tds-side-menu-dropdown-list-item>

  </tds-side-menu-dropdown-list>

</tds-side-menu-dropdown>

@if (authService.isAdmin()) {
<tds-side-menu-item [selected]="isActive('/admin') || onSubRoute('/admin')">
  <a [routerLink]="['/admin']" (click)="toggleMobileSideMenu()">
    <tds-icon name="settings" size="24"></tds-icon>
      Gestão de Prédio
  </a>
</tds-side-menu-item>
}

<div slot="end">
  <tds-side-menu-dropdown>
        
      @if(pic; as profilePic) {
      <tds-side-menu-user slot="label" heading="{{ userName }}" subheading="{{ placeOfWork }}"
        [imgSrc]="profilePic" img-alt=""></tds-side-menu-user>
      } @else {
      <tds-side-menu-user slot="label" heading="{{ userName }}" subheading="{{ placeOfWork }}"
          img-src="https://www.svgrepo.com/show/384676/account-avatar-profile-user-6.svg" img-alt="">
      </tds-side-menu-user>
      }
      
    <tds-side-menu-dropdown-list>

        @if(userReservation()){
        <tds-side-menu-dropdown-list-item>
        <a> 
            Reserva: {{userReservation()?.tableName}} (P{{userReservation()?.building}}-{{userReservation()?.region}})
        </a>
        </tds-side-menu-dropdown-list-item>
        }

      <tds-side-menu-dropdown-list-item>
        <a (click)="toggleMode()">
            @if(mode == "tds-mode-light"){

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width = "24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
            </svg>

            }@else{

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width = "24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
            </svg>

            }
        </a>
      </tds-side-menu-dropdown-list-item>
    </tds-side-menu-dropdown-list>

  </tds-side-menu-dropdown>
</div>

<tds-side-menu-collapse-button slot="sticky-end"></tds-side-menu-collapse-button>

</tds-side-menu>